import { configureStore } from "@reduxjs/toolkit";
import categoryReducer from "./categorySlice";

export const store = configureStore({
  reducer: {
    category: categoryReducer,
  },
});
